import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

export interface UserLogsReportsDownload {
    id: number;
    name: string
    UserEmail: string;
    UserName?: string;
    IP_Address?: string;
    Module?: string;
    Description?: string;
    createdAt?: string;
}

interface UserLogsReportsDownloadState {
    userlogsreportdownloaddata: UserLogsReportsDownload[];
    info: { count: number; current_page: number; limit: number; total_page: number } | null;
    error: string | null;
    loading: boolean;
}

interface UserLogsdownloadReportsParams {
    // id: number;
    limit: number;
    page: number;
    user_id: number | undefined;
    module_name: string;
    ip_address?: string;
    from_date: string;
    to_date: string;
}


export const GetallUserLogsReportDawnlaod = createAsyncThunk<
    Blob,
    UserLogsdownloadReportsParams,
    { rejectValue: string }
>(
    'GetallUserLogsReportDawnlaod',
    async (params, { rejectWithValue }) => {
        const {
            user_id,
            module_name,
            ip_address,
            from_date,
            to_date,
            page,
            limit,
        } = params;
        try {
            const response = await axiosInstance.get(`/api/admin/reports/user-logs/download`, {
                params: {
                    user_id,
                    module_name,
                    ip_address,
                    from_date,
                    to_date,
                    page,
                    limit,
                },
                responseType: 'blob' // Specify that you expect a Blob response
            });
            return response.data; // Return the Blob directly
        } catch (error: any) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue(error.message);
        }
    }
);



const initialState: UserLogsReportsDownloadState = {
    userlogsreportdownloaddata: [],
    info: null,
    error: null,
    loading: false,
};

const userlogsdawnloadSlice = createSlice({
    name: "UserLogsReportsDownload",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // ===============get-all-sms-campaign-wise-reports-dawnlaod-slice-start============
            .addCase(GetallUserLogsReportDawnlaod.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GetallUserLogsReportDawnlaod.fulfilled, (state, action: PayloadAction<Blob>) => {
                state.loading = false;
            })
            .addCase(GetallUserLogsReportDawnlaod.rejected, (state, action: PayloadAction<string | undefined>) => {
                state.loading = false;
                state.error = action.payload || 'An error occurred';
            });
        // ===============get-all-sms-campaign-wise-reports-dawnlaod-slice-end============      
    },
});


export default userlogsdawnloadSlice.reducer;
